import { render, staticRenderFns } from "./WhatsNewSlider.vue?vue&type=template&id=1752876f"
import script from "./WhatsNewSlider.vue?vue&type=script&lang=js"
export * from "./WhatsNewSlider.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/components/whats-new-slider.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports